<template>
  <div class="f-ticket">
    <div class="f-ticket__qr">
      <div class="f-ticket__qr_imgs">
        <img
          height="40"
          src="https://s3.us-west-2.amazonaws.com/joinnus.com/files/joinnus-com-logo.svg"
          alt="jn"
        >
        <div class="f-ticket__qr_qr">
          <img
            width="110"
            :src="`https://qr.joinnus.com/qr.png?size=150&body=${item.code}`"
            alt="qr"
          >
        </div>
      </div>
      <div class="f-ticket__qr_vs">
        <strong>
            {{ metadata.vs.teamPrimary.nameSmall }}
            <small>vs</small>
          {{ metadata.vs.teamSecond.nameSmall }}
        </strong>
        <b>{{ metadata.stadium }}</b><br>
        <span>{{ metadata.dateStart }}</span>
      </div>
      <div class="f-ticket__qr_tribuna">
        <div>
          <small>Tribuna</small>
          <span>{{ ticketTypeDescription || item.ticketTypeName }}</span>
        </div>
        <div v-if="item.puerta" class="tline">
          <small>Pta.</small>
          <span>{{ item.puerta }}</span>
        </div>
      </div>
      <div class="f-ticket__qr_sector">
        <span v-if="sector">Sector</span><b v-if="sector">{{ sector }}</b>
        <span v-if="row">Fila</span><b v-if="row">{{ row }}</b>
        <span v-if="seat">Asiento</span><b v-if="seat">{{ seat }}</b>
        <span>&nbsp;</span>
      </div>
      <div class="f-ticket__qr_info">
        <b>*Recuerda</b>
        tu código QR es lo más importante de tu entrada Joinnus.
        Cuídalo como oro, no lo publiques y no lo compartas con nadie.
      </div>
    </div>
    <div class="f-ticket__body">
      <span class="f-ticket__body_ruc">
        {{ metadata.ruc }}
      </span>
      <small class="f-ticket__body_sure">
        Conserve su ticket. {{ metadata.poliza }}
      </small>
      <div class="f-ticket__body_content">
        <div class="f-ticket__body_head">
          <div class="f-ticket__body_stadium">
            <b>{{ metadata.stadium }}</b>
            <small>{{ metadata.stadiumAddress }}</small>
          </div>
          <div class="f-ticket__body_date">
            <div class="ft-upper">
              <b>{{ metadata.dateStart }}</b>
            </div>
            <div v-if="item.price && item.paymentMethod !== 'package'">
              Precio
              <b>{{ metadata.currency }} {{ item.price }}</b>
            </div>
            <div v-else-if="item.paymentMethod === 'package'">
              <b>Abono</b>
            </div>
            <div v-else>
              <b>Cortesía</b>
            </div>
          </div>
        </div>
        <div class="f-ticket__body_vs">
          <div class="f-ticket-vs">
            <div class="f-ticket-vs__head">
              <b>{{ metadata.tourney }}</b>
            </div>
            <div class="f-ticket-vs__body">
              <img
                v-if="metadata.vs.teamPrimary.logoUrl"
                height="65"
                :src="metadata.vs.teamPrimary.logoUrl"
                alt="jn"
              >
              <div class="f-ticket-vs__vs">
                <!-- <div v-html="metadata.vs.teamPrimary.name"></div> -->
                <div>
                  {{ metadata.vs.teamPrimary.name1 }} <br>
                  {{ metadata.vs.teamPrimary.name2 }}
                </div>
                <b>VS</b>
                <!-- <div v-html="metadata.vs.teamSecond.name"></div> -->
                <div>
                  {{ metadata.vs.teamSecond.name1 }} <br>
                  {{ metadata.vs.teamSecond.name2 }}
                </div>
              </div>
              <img
                v-if="metadata.vs.teamSecond.logoUrl"
                height="65"
                :src="metadata.vs.teamSecond.logoUrl"
                alt="jn"
              >
            </div>
          </div>
        </div>
        <div class="f-ticket__body_tribune">
          <div>
            <div>Tribuna <b>{{ ticketTypeDescription || item.ticketTypeName }}</b></div>
            <div v-if="item.door">Puerta de ingreso <b>{{ item.door }}</b></div>
            <div><b>{{ item.name }} {{ item.lastName }}</b></div>
            <div v-if="item.document">
              {{ item.documentType ? item.documentType : 'DNI' }} <b>{{ item.document }}</b>
            </div>
          </div>
          <div class="ft-body-sector">
            <div v-if="sector"><span>Sector</span> <b>{{ sector }}</b></div>
            <div v-if="row"><span>Fila</span> <b>{{ row }}</b></div>
            <div v-if="seat"><span>Asiento</span> <b>{{ seat }}</b></div>
          </div>
        </div>
        <div class="f-ticket__body_logos">
          <div>
            <img
              v-for="url in metadata.sponsors"
              :src="url"
              :key="url"
              height="18"
              alt="jn"
              style="margin-right: 2px"
            >
          </div>
          <div>
            <img
              class="ft-jn"
              src="https://s3.us-west-2.amazonaws.com/joinnus.com/files/joinnus-com-logo.svg"
              height="40"
              alt="jn"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="f-ticket__info">
      <div class="f-ticket__info_body">
        <div class="f-ticket__info_tribuna">
          <div>
            <div>Tribuna</div>
            <div class="tribunaLg" style="max-width:142px">
              {{ ticketTypeDescription || item.ticketTypeName }}
            </div>
          </div>
          <div v-if="item.door">
            <div>Pta.</div>
            <div class="tribunaLg">
              {{ item.door }}
            </div>
          </div>
          <div v-if="sector">
            <div>Sector</div>
            <div class="tribunaLg">{{ sector }}</div>
          </div>
          <div v-if="row">
            <div>Fila</div>
            <div class="tribunaLg">{{ row }}</div>
          </div>
          <div v-if="seat">
            <div>Asiento</div>
            <div class="tribunaLg">{{ seat }}</div>
          </div>
        </div>
        <div class="f-ticket__info_footer">
          <div class="f-ticket__info_vs">
            <div>
              <strong>
                {{ metadata.vs.teamPrimary.nameSmall }}
                <small>VS</small>
                {{ metadata.vs.teamSecond.nameSmall }}
              </strong>
            </div>
            <div class="f-ticket__info_stadium">
              {{ metadata.stadium }}
              <span>
                {{ metadata.dateStart }}
              </span>
            </div>
          </div>
          <div class="f-ticket__info_price">
            <div v-if="item.price && item.paymentMethod !== 'package'">
              <small>Precio</small>
              {{ metadata.currency }} {{ item.price }}
            </div>
            <div v-else-if="item.paymentMethod === 'package'">
              Abono
            </div>
            <div v-else>
              Cortesía
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="f-ticket__barcode">
      <div class="f-ticket__barcode_body">
        <div class="f-ticket__barcode_head">
          <div class="f-ticket__barcode_data">
            {{ item.name }} {{ item.lastName }}
            <br>
            <span v-if="item.document">
              {{ item.documentType ? item.documentType : 'DNI' }}: {{ item.document }}
            </span>
            <span>&nbsp;</span>
          </div>
          <div class="f-ticket__barcode_price">
            <div v-if="item.price && item.paymentMethod !== 'package'">
              <small>Precio</small>
              {{ metadata.currency }} {{ item.price }}
            </div>
            <div v-else-if="item.paymentMethod === 'package'">
              Abono
            </div>
            <div v-else>
              Cortesía
            </div>
          </div>
        </div>
        <div class="f-ticket__barcode_footer">
          <div>
            <small>Tribuna</small>
            {{ ticketTypeDescription || item.ticketTypeName }}
          </div>
          <div v-if="item.door">
            <small>Pta.</small>
            {{ item.door }}
          </div>
          <div>
            <img
              :src="`https://www.joinnus.com/activity/ticket/${codeBar}/barcode?t=2&h=22`"
              alt="barcode"
              height="22"
              width="140"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Setiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

const weekday = ['DOM', 'LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB'];

const formatTwo = n => (n > 9 ? `${n}` : `0${n}`);

const parseHourString = (time) => {
  const patrs = time.split(':');
  let ampm = ' AM';
  if (patrs[0] >= 12) {
    ampm = ' PM';
  }
  if (patrs[0] > 12) {
    patrs[0] -= 12;
  }
  return `${formatTwo(parseInt(patrs[0], 0))}:${patrs[1]}${ampm}`;
};

const formatDate = (date, isFull) => {
  const d = new Date(date);

  const hour = `${formatTwo(d.getHours())}:${formatTwo(d.getMinutes())}`;
  if (isFull) {
    return `${formatTwo(d.getDate())} ${months[d.getMonth()]} ${d.getFullYear()} - ${parseHourString(hour)}`;
  }
  return `${weekday[d.getDay()]} ${formatTwo(d.getDate())} ${months[d.getMonth()]} - ${parseHourString(hour)}`;
};

const getFieldMeta = (key, item) => {
  if (!item.metadata.length) return {};
  return item.metadata.find(el => el.key === key).charValue;
};

const generateMetadata = (item) => {
  const obj = {};
  const dt = item.dateStart.replace('Z', '');
  obj.currency = item.currency === 'PEN' ? 'S/' : '$';

  obj.dateStart = formatDate(dt);
  obj.stadium = item.addressRef;
  obj.stadiumAddress = item.address;

  obj.ruc = getFieldMeta('sport_ticket_ruc', item);
  obj.poliza = getFieldMeta('sport_ticket_policy', item);
  obj.tourney = getFieldMeta('sport_ticket_championship', item);
  obj.vs = JSON.parse(getFieldMeta('sport_ticket_vs', item));
  obj.sponsors = JSON.parse(getFieldMeta('sport_ticket_sponsors', item));

  return obj;
};

// const seat = 'OCC-LAT-SEC-ROW-A1';

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    codeBar() {
      return this.item.codeBar || this.item.code;
    },
    sector() {
      if (!this.item.seat) return '';
      const arr = this.item.seat.split('-');
      return arr[arr.length - 4];
    },
    row() {
      if (!this.item.seat) return '';
      const arr = this.item.seat.split('-');
      return arr[arr.length - 2];
    },
    ticketTypeDescription() {
      return this.item.ticketTypeDescription;
    },
    metadata() {
      return generateMetadata(this.item);
    },
    seat() {
      if (!this.item.seat) return '';
      const arr = this.item.seat.split('-');
      return arr[arr.length - 1];
    },
  },
};
</script>

<style lang="scss" scoped>
$h: 335px;
.f-ticket-vs{
  &__head{
    text-transform: uppercase;
    font-size: 10px;
  }
  &__body{
    display: flex;
    align-items: center;
    padding: 2px 2px;
    border-top: 3px solid #000;
    border-bottom: 3px solid #000;
  }
  &__vs{
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
    padding-left: 4px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    b{
      padding: 5px;
      font-size: 140%;
    }
  }
}

.ft-body-sector{
  display: table;
  > div{
    width: 80px;
    display: flex;
    justify-content: space-between;
  }
}

.f-ticket{
  font-family: 'Open Sans', sans-serif;
  margin: 20px auto;
  width: 755px;
  height: $h;
  background: #eee;
  border-radius: 10px;
  display: flex;
  position: relative;
  box-shadow: 1px 1px 1px rgba(0,0,0, 0.15);
  &:before{
    content: "";
    position: absolute;
    top: 15px;
    left: 160px;
    width: 405px;
    height: 7px;
    background: red;
    z-index: 1;
    opacity: 0.8;
  }
  &:after{
    content: "";
    position: absolute;
    top: 10px;
    left: 190px;
    width: 495px;
    height: $h - 20px;
    background: rgba(#000, 0.1);
  }
  *{
    box-sizing: border-box;
  }
  .ft-upper{
    text-transform: uppercase;
  }
  &__qr{
    width: 180px;
    flex-shrink: 0;
    padding: 10px;
    border-right: 1px dashed #999;
    &_imgs{
      text-align: center;
      padding: 3px 0 7px;
    }
    &_qr{
      // margin-top: 10px;
      margin-top: -3px;
      position: relative;
      span{
        font-size: 12px;
        display: block;
        width: 110px;
        position: absolute;
        bottom: 5px;
        left: 0;
        transform-origin: left bottom;
        transform: rotate(-90deg) translateY(15px);
      }
    }
    &_vs{
      margin-top: -5px;
      text-transform: uppercase;
      font-size: 8px;
      line-height: 1.2;
      strong{
        display: block;
        font-size: 22px;
        font-weight: 700;
        margin-bottom: 2px;
      }
    }
    &_tribuna{
      margin-top: 3px;
      display: flex;
      justify-content: space-between;
      font-size: 10px;
      font-weight: 700;
      .tline{
        padding-left: 10px;
        padding-right: 5px;
        border-left: 1px solid #000;
      }
      > div{
        padding: 2px 0;
      }
      small{
        display: block;
        font-weight: 600;
      }
    }
    &_sector{
      font-size: 11px;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #000;
    }
    &_info{
      font-size: 6px;
      text-align: justify;
      margin-top: 5px;
    }
  }
  &__body{
    flex-shrink: 0;
    width: 400px;
    border-right: 1px dashed #999;
    position: relative;
    z-index: 9;
    &_ruc{
      text-transform: uppercase;
      text-align: center;
      font-weight: 400;
      font-size: 10px;
      display: block;
      width: $h;
      position: absolute;
      left: 0;
      bottom: 0;
      transform-origin: left bottom;
      transform: rotate(-90deg) translateY(25px);
    }
    &_sure{
      position: absolute;
      bottom: 13px;
      left: 40px;
      font-size: 6px;
      font-weight: 600;
    }
    &_content{
      padding: 30px 20px 20px 40px;
    }
    &_head{
      display: flex;
      justify-content: space-between;
      font-size: 12px;
    }
    &_stadium{
      text-transform: uppercase;
      b{
        display: block;
      }
    }
    &_date{
      text-align: right;
    }
    &_vs{
      margin-top: 10px;
    }
    &_tribune{
      font-size: 14px;
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      b{
        text-transform: uppercase;
      }
    }
    &_logos{
      margin-top: -4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      left: 40px;
      right: 20px;
      bottom: 16px;
      .ft-jn{
        position: relative;
        right: -7px;
      }
    }
  }
  &__info{
    flex-shrink: 0;
    position: relative;
    width: 100px;
    border-right: 1px dashed #999;
    position: relative;
    z-index: 9;
    &_body{
      width: $h;
      overflow: hidden;
      height: 100px;
      padding: 5px 20px;
      position: absolute;
      bottom: 0;
      transform-origin: left bottom;
      transform: rotate(-90deg) translateY(100px);
    }
    &_footer{
      line-height: 1.2;
      margin-top: 7px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
    &_stadium{
      font-weight: 600;
      text-transform: uppercase;
      font-size: 10px;
      span{
        font-weight: 400;
        display: block;
      }
    }
    &_price{
      font-size: 18px;
      font-weight: 600;
      small{
        font-weight: 400;
        font-size: 12px;
        display: block;
      }
    }
    &_tribuna{
      display: flex;
      justify-content: space-between;
      font-weight: 400;
      font-size: 12px;
      line-height: 1.1;
      > div{
        padding: 3px 0;
      }
      .tribunaLg{
        font-weight: 600;
        font-size: 110%;
      }
    }
  }
  &__barcode{
    flex-shrink: 0;
    position: relative;
    width: 75px;
    &_body{
      width: $h;
      overflow: hidden;
      height: 100px;
      padding: 7px 20px;
      position: absolute;
      bottom: 0;
      transform-origin: left bottom;
      transform: rotate(-90deg) translateY(100px);
    }
    &_head{
      font-size: 10px;
      display: flex;
      justify-content: space-between;
    }
    &_data{
      font-weight: 600;
      text-transform: uppercase;
    }
    &_price{
      font-weight: 600;
      font-size: 13px;
      line-height: 1.1;
      small{
        font-weight: 400;
        display: block;
      }
    }
    &_footer{
      margin-top: 5px;
      font-size: 10px;
      font-weight: 600;
      line-height: 1.1;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      small{
        font-weight: 400;
        display: block;
      }
    }
  }
}
</style>
